import { inject, injectable } from "@launchtray/tsyringe-async";
import { IPushModel } from "./IPushModel";
import { Bindable } from "../../../../../shared/bindable-data";
import { INetworkClient } from "../../../../networking/INetworkClient";
import { PlayerDto } from "../../../../networking/data/responses/user/PlayerDto";

@injectable()
export class PushModel extends Bindable implements IPushModel {
    private readonly networkClient: INetworkClient;

    public constructor(
        @inject("INetworkClient") networkClient: INetworkClient
    ) {
        super();
        this.networkClient = networkClient;
    }

    public async allowPushNotification(isNotificationDialogAvailable: boolean, result?: PushSubscription, timeout?: boolean): Promise<PlayerDto> {
        return await this.networkClient.sendPushSubscription(isNotificationDialogAvailable, result, timeout);
    }
}
